import { Breadcrumbs } from '@mantine/core'
import BreadcrumbsClasses from './styles.module.css'
import '../../styles/variables.css'

export default Breadcrumbs.extend({
    defaultProps: {},
    classNames: BreadcrumbsClasses,
})
